import { makeRequest, SADUKA_TRANSPORT_PREFIX } from 'cityads-v3/utils/apiUtils';
import { prepareLanguage, DEFAULT_LANGUAGE } from 'cityads-v3/i18n/utils';
import config from 'cityads-v3/config';

export const SET_LANGUAGE         = 'language/SET_LANGUAGE';
export const SET_LANGUAGE_SUCCESS = 'language/SET_LANGUAGE_SUCCESS';
export const SET_LANGUAGE_FAILURE = 'language/SET_LANGUAGE_FAILURE';
export const SET_LANGUAGE_FROM_SERVER = 'language/SET_LANGUAGE_FROM_SERVER';

export const GET_SADUKA_LANGUAGES = "language/GET_SADUKA_LANGUAGES";
export const GET_SADUKA_LANGUAGES_SUCCESS = "language/GET_SADUKA_LANGUAGES_SUCCESS";
export const GET_SADUKA_LANGUAGES_FAIL = "language/GET_SADUKA_LANGUAGES_FAIL";

export function setLanguage({ language: lang, i18n }) {
  const language = prepareLanguage(lang) || DEFAULT_LANGUAGE;

  return function (dispatch, getState, extraArgument) {
    const { isLoggedIn } = getState().auth;

    dispatch({
      type: SET_LANGUAGE,
      additional: {
        language,
      },
    });

    return Promise.all([
      isLoggedIn ?
        makeRequest(`${config.AUTH_URL}/action/change/language?language=${language}`, {
          language,
          types: [],
          options: {
            credentials: 'include',
            referrerPolicy: 'no-referrer',
          }
        })(dispatch, getState, extraArgument) :
        null
      ,
      i18n.reloadResources(language),
    ])
      .then(([ authResponse, _ ]) => {
        i18n.changeLanguage(language);

        dispatch({
          type: SET_LANGUAGE_SUCCESS,
          response: authResponse,
          additional: {
            language,
          },
        })
      })
      .catch(error => {
        dispatch({
          type: SET_LANGUAGE_FAILURE,
          response: error,
          additional: {
            language,
          },
        });

        throw error;
      })
    ;
  }
}

export function setLanguageFromServer(initialLanguage) {
  return {
    type: SET_LANGUAGE_FROM_SERVER,
    additional: {
      language: initialLanguage
    }
  }
}

export function getSadukaLanguages() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/languages?perpage=1000`, {
    types: [GET_SADUKA_LANGUAGES, GET_SADUKA_LANGUAGES_SUCCESS, GET_SADUKA_LANGUAGES_FAIL],
    options: {
      credentials: 'include'
    }
  });
}
